// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"7e02647e","213":"1554f4e6","453":"260fd53b"}[chunkId] + ".chunk.js";
};